import React, { FunctionComponent, useState } from 'react';
import { Button, Icon, Modal } from '@scuf/common';
import { ERROR_MSG_FOR_USER_RESPONSE, COMMENT_NOTE, HAS_SCRIPT, COMMENT_UPLOAD_TYPE, } from '../../../../constants/constants';
import { useAppDispatch } from '../../../../store';
import { updateCommentsBox, updateCommentsBoxImage } from '../../../../services/UserAction';
import { ICommentModal } from '../../../../models/IOpportunitiesAPIModel';
import './Notes.scss';
import "../../NewCardDesign/CommonStyle.scss";
import { FileUpload } from '../../../../components/UploadFileModal/FileUpload';
import CommentBox from 'src/components/CommentBox/CommentBox';
import { ICommentBoxValue } from 'src/components/CommentBox/ICommentBoxProps';
import { tagEvent, TAG_EVENT_CONST } from 'src/utils/analytics/analytics.service.util';
import { getCommentsDetail, setCommentStatus } from 'src/slices/allOpportunitySlice';
import { getMessage } from 'src/message/utils';
import DOMPurify from 'dompurify';

interface INotesFooterProps {
    onClose: Function;
    opportunityId: any;
    open?: boolean;
    opportunityObjectName: any;
    isAllAnomaly?:boolean;
}

const NotesFooter: FunctionComponent<INotesFooterProps> = (props) => {
    const [commentValue, setCommentValue] = useState<ICommentBoxValue[]>([]);
    const [commentEmpty, setCommentEmpty] = useState<boolean>(true);
    const [makeCommentEmpty, setMakeCommentEmpty] = useState<boolean>(false);
    const [enableRetryErr, setEnableRetryErr] = useState(false);
    const [hasScript, setHasScript] = useState(false);
    const [isUploaded, setIsUploaded] = useState(false);
    const dispatch = useAppDispatch();
    const [acceptActionInProgress, setacceptActionInProgress] = useState(false);
    const addCommentBtn = getMessage('app.anomalydetails.comment.commentbtn');
    const [btnText, setBtnText] = useState(addCommentBtn);
    const [commentList, setCommentList] = useState([] as any);
    const addCommentPlaceholder = getMessage('app.anomalydetails.comment.commentplaceholder');
    const commentNoteText = getMessage('app.anomalydetails.comment.commentnote');
    const addingData = getMessage('app.anomalydetails.comment.adding');
    const cancelBtn = getMessage('app.anomalydetails.comment.cancel');
    const uploadText = getMessage('app.anomalydetails.comment.upload');
    const warningText = getMessage('app.notes.footer.warning');

    const addComments = async () => {
        setEnableRetryErr(false);
        setacceptActionInProgress(true);
        setBtnText(addingData);
        try {
            const results = [];
            for await (const comment of commentValue) {

                if (comment?.type === 'text' && comment?.content?.trim().length !== 0) {
                    const content = comment?.content?.trim() || ''
                    const data: ICommentModal = {
                        user_comment: content,
                        type: 'comment',
                    };
                    const response = await dispatch(
                        updateCommentsBox(props.opportunityId, data)
                    );
                    //TODO: analysis pass proper key
                    tagEvent(TAG_EVENT_CONST.comment, { AnomalyId: props.opportunityId });
                    results.push(response);
                    addComment(content);
                    
                } else if (comment?.type === 'image') {
                    const imageFile = comment?.file || null;
                    let formData = new FormData();
                    if (imageFile) {
                        formData.append(`supportFile`, imageFile);
                    }
                    const response = await dispatch(
                        updateCommentsBoxImage(
                            props.opportunityId,
                            formData,
                            COMMENT_UPLOAD_TYPE
                        )
                    );
                    results.push(response);
                }
            }
            dispatch(getCommentsDetail(props.opportunityId));
            dispatch(setCommentStatus('finished'));
            setacceptActionInProgress(false);
            setBtnText(addCommentBtn);
            setMakeCommentEmpty(true);
        } catch (error) {
            dispatch(setCommentStatus('finished'));
            setacceptActionInProgress(false);
            setEnableRetryErr(true);
            setBtnText(addCommentBtn);
        }
    };

    const onCommentChange = (value: any) => {
        setCommentValue(value);
    }

    const addComment = (userInput: any) => {
        let comment = [...commentList];
        comment = [...comment, userInput];
        setCommentList(comment);
    };

    return (
        <div className={props.isAllAnomaly?'':'notes-footer'}>
            <Modal.Footer className="comments__footer">
            <div className='email-error mt-3' dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(warningText,{
                ALLOWED_ATTR:['href', 'target']
            })}}></div>
                <CommentBox placeholder={addCommentPlaceholder} onChange={(value) => onCommentChange(value)}
                    isEmpty={(empty) => setCommentEmpty(empty)} makeCommentEmpty={makeCommentEmpty} setMakeCommentEmpty={setMakeCommentEmpty}
                    excludeTextRegex={/[<>()&#]/} onRegexError={(error) => setHasScript(error)}
                    className={props.isAllAnomaly?"all-anomaly":""}
                    />
                {/* File Uplaod needs to be added */}
                <FileUpload
                    // @ts-ignore
                    anomaly_id={props.opportunityObjectName}
                    opportunityId={props.opportunityId}
                    type={COMMENT_UPLOAD_TYPE}
                    // isUploaded={isUploaded}
                    updateUploadedStatus={(uploaded: boolean) => setIsUploaded(uploaded)} className={''}          //  addedcomment={addedcomment}
                />
                {/* <Card.Header  /> */}
                <div className="comment_note">{commentNoteText}</div>
                {hasScript && <div className="has_script">{HAS_SCRIPT}</div>}
                {isUploaded && <div className="has_script">{uploadText}</div>}
                {enableRetryErr && (
                    <div className="notes-error-text">{ERROR_MSG_FOR_USER_RESPONSE}</div>
                )}
                <div className='pop-footer'>
                    <Button
                        className="button--secondary notes-cancel button-space"
                        size="small"
                        type="secondary"
                        disabled={acceptActionInProgress}
                        onClick={() => {
                            props.onClose();
                        }}
                        content={cancelBtn}
                    />
                    <Button
                        data-testid="note-add__comment"
                        className={`button--primary notes-add--comment ${acceptActionInProgress ? 'notes__footer--readonly btn-loading' : ''
                            } button-space`}
                        icon={
                            enableRetryErr ? (
                                <Icon
                                    root="building"
                                    name="refresh"
                                    exactSize={22}
                                    className="notes__footer--retry"
                                />
                            ) : (
                                ''
                            )
                        }
                        iconPosition="right"
                        size="small"
                        // disabled={ acceptActionInProgress || newNote.trimStart() === '' || isUploaded}
                        disabled={acceptActionInProgress || commentEmpty || hasScript || isUploaded}
                        type="primary"
                        // onClick={addNewNote}
                        onClick={addComments}
                        content={btnText}
                    />
                </div>
            </Modal.Footer>
        </div>
    )

}

export default NotesFooter;